import { useEffect } from 'react'
import { useObject } from 'react-firebase-hooks/database'
import { useHistory } from 'react-router'
import { toast } from 'react-toastify'
import { CurrentUserType } from 'src/ducks/auth'
import { ClosePathToLobbyRef, GalleryAccessRef, GameAccessRef, LobbyAccessRef, NetworkingAccessRef } from 'src/firebaseConfig'
import routes from 'src/routes'

export enum PageEnum {
  Lobby = 'lobby',
  Networking = 'networking',
  Game = 'game',
  Gallery = 'gallery',
}

type PageAccessProps = {
  currentUser: CurrentUserType
  page: PageEnum
  toastMsg?: string
}

const PageRefMap = {
  [PageEnum.Lobby]: LobbyAccessRef,
  [PageEnum.Networking]: NetworkingAccessRef,
  [PageEnum.Game]: GameAccessRef,
  [PageEnum.Gallery]: GalleryAccessRef,
}

export default function usePageAccess({ currentUser, page, toastMsg = 'This page is currently closed' }: PageAccessProps) {
  const [closePathSnapshot, closePathLoading, closePathError] = useObject(ClosePathToLobbyRef)

  const getClosePath = () => {
    if (closePathLoading || closePathError) return null
    return closePathSnapshot?.val() === 'on' // True = Redirect to lobby when page is closed
  }

  const [snapshot, loading, error] = useObject(PageRefMap[page])
  const history = useHistory()

  const route = getClosePath() ? routes.lobby : routes.auditorium

  useEffect(() => {
    if (currentUser.role !== 'superadmin' && !loading && snapshot && snapshot.val() === 'on') {
      history.push(route)
      toast.info(toastMsg)
    }
  }, [snapshot])

  return !!snapshot
}
